// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".region-featured-products-section[data-v-6dca46e8]{padding:40px 0}.title[data-v-6dca46e8]{margin-bottom:40px;font-weight:700}@media(min-width:576px){.mobile-gutter[data-v-6dca46e8]{padding:0}}@media(min-width:1377px){.listings-container[data-v-6dca46e8]{padding-left:80px;padding-right:80px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
